// import { useEffect } from "react";
import { useEmployeeAuth } from "./AdminProvider"
import { useNavigate } from "react-router-dom"
export const RequirePWD = ({children}) =>{
    const auth = useEmployeeAuth()
    const navigate = useNavigate();
    if (!auth.hasPWD===true){
      navigate("/admin/login/", {replace:true})
    }
    // useEffect(()=>{
    //   if (!auth.hasPWD===true){
    //     navigate("/admin/login/", {replace:true})
    //   }
    // }, [])
    return children
    
    
    
    
}